import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import ThemeContext from './context/ThemeContext';
import { persistor, store } from '@framework/redux';
import GlobalLoader from '@jsx/components/Loader/GlobalLoader';
import ToastNotificationContext from '@context/ToastNotificationContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<GlobalLoader />} persistor={persistor}>
        <BrowserRouter>
          <ThemeContext>
            <ToastNotificationContext>
              <App />
            </ToastNotificationContext>
          </ThemeContext>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
